/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelWith4CountsValue
 */
export interface LabelWith4CountsValue {
    /**
     * 
     * @type {string}
     * @memberof LabelWith4CountsValue
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof LabelWith4CountsValue
     */
    count1: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith4CountsValue
     */
    count2: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith4CountsValue
     */
    count3: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith4CountsValue
     */
    count4: number;
}

/**
 * Check if a given object implements the LabelWith4CountsValue interface.
 */
export function instanceOfLabelWith4CountsValue(value: object): value is LabelWith4CountsValue {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('count1' in value) || value['count1'] === undefined) return false;
    if (!('count2' in value) || value['count2'] === undefined) return false;
    if (!('count3' in value) || value['count3'] === undefined) return false;
    if (!('count4' in value) || value['count4'] === undefined) return false;
    return true;
}

export function LabelWith4CountsValueFromJSON(json: any): LabelWith4CountsValue {
    return LabelWith4CountsValueFromJSONTyped(json, false);
}

export function LabelWith4CountsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelWith4CountsValue {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'count1': json['count1'],
        'count2': json['count2'],
        'count3': json['count3'],
        'count4': json['count4'],
    };
}

export function LabelWith4CountsValueToJSON(value?: LabelWith4CountsValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'count1': value['count1'],
        'count2': value['count2'],
        'count3': value['count3'],
        'count4': value['count4'],
    };
}

